/* Zoss — carrinho, sacola lateral, menu e analytics.
 *
 * Roda em todas as páginas. Expõe window.ZossCart para as outras telas
 * (home, página de produto, página de carrinho).
 *
 * Modos: 'shopify' (Cart AJAX API) e 'preview' (carrinho em memória).
 */
window.ZossCart = (function () {
  'use strict';

  var DATA = window.ZOSS_DATA || {};
  var PREVIEW = DATA.mode === 'preview';
  var CURRENCY = DATA.currency || 'BRL';
  var LOCALE = DATA.locale || 'pt-BR';
  var INSTALLMENTS = parseInt(DATA.installments, 10) || 6;
  var R = DATA.routes || {};

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function money(cents) {
    return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format((cents || 0) / 100);
  }

  /* ------------------------------------------------------------ analytics */

  var FB_MAP = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', sign_up: 'Lead', search: 'Search' };
  var TT_MAP = { view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', sign_up: 'SubmitForm', search: 'Search' };

  function track(name, payload) {
    payload = payload || {};
    var items = payload.items || [];
    var eventId = payload.event_id || ('zoss_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9));
    payload.event_id = eventId;

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}

    try {
      if (window.ttq && typeof window.ttq.track === 'function' && TT_MAP[name]) {
        window.ttq.track(TT_MAP[name], {
          contents: items.map(function (i) {
            return { content_id: String(i.item_id), content_type: 'product', content_name: i.item_name, quantity: i.quantity || 1, price: i.price };
          }),
          value: payload.value,
          currency: CURRENCY,
          event_id: eventId
        });
      }
    } catch (e) {}

    document.dispatchEvent(new CustomEvent('zoss:' + name, { detail: payload, bubbles: true }));
  }

  function lineItems(cart) {
    return (cart.items || []).map(function (l) {
      return {
        item_id: l.variant_id || l.id,
        item_name: l.product_title || l.title,
        item_variant: l.variant_title,
        item_brand: 'Zoss',
        price: (l.price || 0) / 100,
        quantity: l.quantity
      };
    });
  }

  /* -------------------------------------------------------------- adapters */

  function ShopifyCart() {
    var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
    this.get = function () {
      return fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    };
    this.add = function (variantId, qty, properties) {
      var item = { id: variantId, quantity: qty || 1 };
      if (properties) item.properties = properties;
      return fetch((R.cart_add || '/cart/add') + '.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [item] }) })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Não deu para adicionar');
            return body;
          });
        });
    };
    this.change = function (key, qty) {
      return fetch((R.cart_change || '/cart/change') + '.js', { method: 'POST', headers: json, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Não deu para atualizar');
            return body;
          });
        });
    };
    this.checkout = function () { window.location.href = R.cart || '/cart'; };
  }

  // Preview: reproduz o formato do /cart.js e simula o desconto automático.
  function PreviewCart() {
    var items = [];
    var catalog = window.ZOSS_PREVIEW_PRODUCTS || [];

    function find(variantId) {
      var hit = null;
      catalog.forEach(function (p) {
        (p.variants || []).forEach(function (v) { if (String(v.id) === String(variantId)) hit = { p: p, v: v }; });
      });
      return hit;
    }
    function recalc() {
      items.forEach(function (l) {
        l.original_line_price = l.price * l.quantity;
        l.final_line_price = l.original_line_price;
      });
    }
    function snapshot() {
      var subtotal = items.reduce(function (a, l) { return a + l.original_line_price; }, 0);
      var qty = items.reduce(function (a, l) { return a + l.quantity; }, 0);
      var unit = items.length ? Math.min.apply(null, items.map(function (l) { return l.price; })) : 0;
      var discount = Math.floor(qty / 2) * unit;
      return {
        item_count: qty,
        items: items.map(function (l) { return Object.assign({}, l); }),
        items_subtotal_price: subtotal,
        total_discount: discount,
        total_price: subtotal - discount,
        cart_level_discount_applications: discount ? [{ title: 'Compre 1 Leve 2', total_allocated_amount: discount }] : []
      };
    }

    this.get = function () { return Promise.resolve(snapshot()); };
    this.add = function (variantId, qty) {
      var hit = find(variantId);
      if (!hit) return Promise.reject(new Error('Variante não encontrada'));
      var line = items.filter(function (l) { return String(l.variant_id) === String(variantId); })[0];
      if (line) {
        line.quantity += qty || 1;
      } else {
        items.push({
          key: 'preview:' + variantId,
          id: variantId,
          variant_id: variantId,
          product_id: hit.p.id,
          product_title: hit.p.title,
          variant_title: hit.v.title,
          image: hit.v.image || hit.p.image,
          url: hit.p.url,
          price: hit.v.price,
          quantity: qty || 1
        });
      }
      recalc();
      return Promise.resolve(snapshot());
    };
    this.change = function (key, qty) {
      items = items.map(function (l) { return l.key === key ? Object.assign(l, { quantity: qty }) : l; })
        .filter(function (l) { return l.quantity > 0; });
      recalc();
      return Promise.resolve(snapshot());
    };
    this.checkout = function () { toast('No preview o checkout não abre. Na loja vai para /checkout.'); };
  }

  var api = PREVIEW ? new PreviewCart() : new ShopifyCart();
  var CART = { item_count: 0, items: [], total_price: 0, total_discount: 0, cart_level_discount_applications: [] };

  /* ----------------------------------------------------------------- toast */

  var toastTimer;
  function toast(msg) {
    var wrap = $('[data-zs-toast]');
    if (!wrap) return;
    clearTimeout(toastTimer);
    $('span', wrap).textContent = msg;
    wrap.hidden = false;
    toastTimer = setTimeout(function () { wrap.hidden = true; }, 2400);
  }

  /* ------------------------------------------------------------- interface */

  function render() {
    var qty = CART.item_count || 0;
    var eligibleQty = promotionQuantity(CART);
    var pairs = Math.floor(eligibleQty / 2);
    var odd = eligibleQty % 2 === 1;
    var total = CART.total_price || 0;

    $$('[data-zs-count]').forEach(function (b) { b.hidden = qty === 0; b.textContent = qty; });

    var list = $('[data-zs-lines]');
    if (list) {
      list.textContent = '';
      (CART.items || []).forEach(function (l) { list.appendChild(lineRow(l)); });
    }

    var empty = $('[data-zs-empty]');
    if (empty) empty.hidden = qty > 0;

    var msg = $('[data-zs-progress-msg]');
    if (msg) {
      msg.textContent = eligibleQty === 0
        ? (DATA.free_pair_message || 'Coloque dois óculos aqui. O segundo sai por nossa conta.')
        : odd
          ? 'Falta um óculos para o próximo sair de graça.'
          : (CART.total_discount > 0
            ? (pairs > 1 ? pairs + ' óculos saem de graça.' : 'Um óculos sai de graça.')
            : 'Dupla montada. Confira o desconto da oferta antes de finalizar.');
    }
    var fill = $('[data-zs-progress-fill]');
    if (fill) fill.style.width = eligibleQty === 0 ? '4%' : odd ? '50%' : '100%';

    renderTiers(total);
    renderUpsell(eligibleQty, qty);

    var discount = CART.total_discount || 0;
    var saveRow = $('[data-zs-save-row]');
    if (saveRow) {
      saveRow.hidden = discount <= 0;
      var app = (CART.cart_level_discount_applications || [])[0];
      $('[data-zs-save-label]', saveRow).textContent = app ? app.title : 'Desconto';
      $('[data-zs-save-value]', saveRow).textContent = '− ' + money(discount);
    }

    $$('[data-zs-total]').forEach(function (n) { n.textContent = money(total); });
    $$('[data-zs-subtotal]').forEach(function (n) { n.textContent = money(CART.items_subtotal_price || total); });

    var inst = $('[data-zs-installment]');
    if (inst) {
      inst.textContent = total > 0
        ? 'ou ' + INSTALLMENTS + 'x de ' + money(total / INSTALLMENTS) + ' sem juros, no cartão'
        : 'Parcele em até ' + INSTALLMENTS + 'x sem juros, ou pague no Pix';
    }

    $$('[data-zs-checkout]').forEach(function (button) {
      button.disabled = qty === 0;
      button.hidden = qty === 0;
    });
    $$('[data-zs-cart-foot]').forEach(function (foot) { foot.hidden = qty === 0; });

    var barTitle = $('[data-zs-bar-title]');
    if (barTitle) {
      var barSub = $('[data-zs-bar-sub]');
      var barCta = $('[data-zs-bar-cta]');
      barTitle.textContent = qty === 0 ? (DATA.bar_title || '') : money(total) + (CART.total_discount > 0 ? ' com desconto' : '');
      barSub.textContent = qty === 0
        ? (DATA.bar_sub || '')
        : qty + (qty > 1 ? ' itens na sacola' : ' item na sacola');
      barCta.textContent = qty === 0 ? (DATA.bar_cta || 'Escolher') : 'Ver sacola';
      barCta.dataset.mode = qty === 0 ? 'scroll' : 'cart';
    }
  }

  function promotionQuantity(cart) {
    return (cart.items || []).reduce(function (total, item) {
      var properties = item.properties || {};
      var explicit = String(properties._zoss_promo_eligible || '').toLowerCase() === 'true';
      var type = String(item.product_type || '').toLowerCase();
      var title = String(item.product_title || item.title || '').toLowerCase();
      var eyewear = /óculos|oculos/.test(type + ' ' + title);
      var excluded = /acessório|acessorio|case|flanela|limpa|gift|presente/.test(type + ' ' + title);
      return total + ((explicit || eyewear) && !excluded ? (item.quantity || 0) : 0);
    }, 0);
  }

  // Faixas de frete grátis e brinde, ordenadas pelo valor. Mostra sempre a
  // próxima que ainda falta, com barra de progresso até a faixa mais alta.
  function renderTiers(subtotal) {
    var wrap = $('[data-zs-ship]');
    var msg = $('[data-zs-ship-msg]');
    var fill = $('[data-zs-ship-fill]');
    if (!msg) return;

    function visible(state) {
      if (wrap) wrap.hidden = !state;
      else msg.hidden = !state;
    }

    var tiers = [];
    if (DATA.gift_threshold > 0) tiers.push({ v: DATA.gift_threshold, label: DATA.gift_label || 'brinde' });
    if (DATA.free_ship_threshold > 0) tiers.push({ v: DATA.free_ship_threshold, label: 'frete grátis' });
    if (!tiers.length || subtotal === 0) { visible(false); return; }
    tiers.sort(function (a, b) { return a.v - b.v; });

    var next = tiers.filter(function (t) { return subtotal < t.v; })[0];
    if (next) {
      msg.textContent = 'Faltam ' + money(next.v - subtotal) + ' para o ' + next.label + '.';
    } else {
      // Sem adjetivo: o rótulo do brinde é editável no tema, então
      // "liberado/liberada/liberados" erraria a concordância conforme o texto.
      var todos = tiers.map(function (t) { return t.label; }).join(' e ');
      msg.textContent = 'Você já tem ' + todos + '.';
    }
    var top = tiers[tiers.length - 1];
    if (fill) fill.style.width = Math.min(100, Math.round(subtotal / top.v * 100)) + '%';
    visible(true);
  }

  // Upsell do 2º par: aparece quando falta 1 óculos para fechar a dupla.
  // Esconde os modelos que já estão na sacola e mostra no máximo 3.
  function renderUpsell(eligibleQty, qty) {
    var wrap = $('[data-zs-upsell]');
    if (!wrap) return;
    var show = qty > 0 && eligibleQty % 2 === 1;
    if (!show) { wrap.hidden = true; return; }
    var inCart = {};
    (CART.items || []).forEach(function (l) { if (l.product_id) inCart[String(l.product_id)] = true; });
    var shown = 0;
    $$('[data-zs-upsell-card]', wrap).forEach(function (card) {
      var ok = !inCart[String(card.dataset.productId)] && shown < 3;
      card.hidden = !ok;
      if (ok) shown += 1;
    });
    wrap.hidden = shown === 0;
  }

  function lineRow(l) {
    var row = document.createElement('div');
    row.className = 'zs-line';

    var link = document.createElement('a');
    link.href = l.url || '#';
    link.className = 'zs-line__media';
    var img = document.createElement('img');
    img.className = 'zs-line__img';
    img.loading = 'lazy';
    img.src = l.image || '';
    img.alt = l.product_title || '';
    link.appendChild(img);
    row.appendChild(link);

    var body = document.createElement('div');
    body.className = 'zs-line__body';

    var top = document.createElement('div');
    top.className = 'zs-line__top';
    var name = document.createElement('a');
    name.className = 'zs-line__name';
    name.href = l.url || '#';
    name.textContent = l.product_title || l.title;
    top.appendChild(name);
    var rm = document.createElement('button');
    rm.type = 'button';
    rm.className = 'zs-line__remove';
    rm.textContent = 'remover';
    rm.addEventListener('click', function () { setQty(l, 0); });
    top.appendChild(rm);
    body.appendChild(top);

    if (l.variant_title && l.variant_title !== 'Default Title') {
      var opt = document.createElement('div');
      opt.className = 'zs-line__opt';
      opt.textContent = l.variant_title;
      body.appendChild(opt);
    }

    var bottom = document.createElement('div');
    bottom.className = 'zs-line__bottom';

    var stepper = document.createElement('div');
    stepper.className = 'zs-step-qty';
    var dec = document.createElement('button');
    dec.type = 'button';
    dec.textContent = '−';
    dec.setAttribute('aria-label', 'Diminuir quantidade de ' + l.product_title);
    dec.addEventListener('click', function () { setQty(l, l.quantity - 1); });
    var count = document.createElement('span');
    count.textContent = l.quantity;
    var inc = document.createElement('button');
    inc.type = 'button';
    inc.textContent = '+';
    inc.setAttribute('aria-label', 'Aumentar quantidade de ' + l.product_title);
    inc.addEventListener('click', function () { setQty(l, l.quantity + 1); });
    stepper.appendChild(dec); stepper.appendChild(count); stepper.appendChild(inc);
    bottom.appendChild(stepper);

    var price = document.createElement('div');
    price.className = 'zs-line__price';
    price.textContent = money(l.final_line_price != null ? l.final_line_price : l.original_line_price);
    if ((l.original_line_price || 0) > (l.final_line_price || 0)) {
      var s = document.createElement('s');
      s.textContent = money(l.original_line_price);
      price.appendChild(s);
    }
    bottom.appendChild(price);

    body.appendChild(bottom);
    row.appendChild(body);
    return row;
  }

  /* ------------------------------------------------------------------ ações */

  function refresh() {
    return api.get().then(function (c) {
      CART = c;
      render();
      document.dispatchEvent(new CustomEvent('zoss:cart_updated', { detail: c, bubbles: true }));
      return c;
    }).catch(function (error) {
      toast('Não foi possível atualizar a sacola. Tente novamente.');
      throw error;
    });
  }

  function add(variantId, qty, meta) {
    meta = meta || {};
    var properties = meta.properties || {};
    if (meta.promoEligible !== false) properties._zoss_promo_eligible = 'true';
    return api.add(variantId, qty || 1, properties)
      .then(function () {
        track('add_to_cart', {
          items: [{
            item_id: variantId,
            item_name: meta.title || '',
            item_variant: meta.variant || '',
            item_brand: 'Zoss',
            price: (meta.price || 0) / 100,
            quantity: qty || 1
          }],
          value: ((meta.price || 0) * (qty || 1)) / 100,
          content_name: meta.title || ''
        });
        return refresh();
      })
      // A sacola abre logo em seguida e já mostra o item, então o toast só
      // aparece quando a sacola não abre (por exemplo em telas sem drawer).
      .then(function (c) {
        if ($('[data-zs-cart]')) openCart();
        else toast((meta.title || 'Produto') + ' foi para a sacola');
        return c;
      });
  }

  function setQty(line, qty) {
    var panel = $('[data-zs-cart]');
    if (panel) panel.classList.add('is-busy');
    var removing = qty < line.quantity;
    return api.change(line.key, qty)
      .then(function () {
        if (removing) {
          track('remove_from_cart', {
            items: [{
              item_id: line.variant_id || line.id,
              item_name: line.product_title,
              item_variant: line.variant_title,
              price: (line.price || 0) / 100,
              quantity: line.quantity - qty
            }],
            value: ((line.price || 0) * (line.quantity - qty)) / 100,
            content_name: line.product_title
          });
        }
        return refresh();
      })
      .then(function (c) { if (panel) panel.classList.remove('is-busy'); return c; })
      .catch(function (e) { if (panel) panel.classList.remove('is-busy'); toast('Não deu para atualizar a sacola'); });
  }

  /* -------------------------------------------------------------- checkout */

  // A operação usa Yampi como checkout único. Se o integrador não carregar,
  // preservamos o carrinho e levamos o cliente à página da sacola para tentar
  // novamente, sem trocar silenciosamente de provedor.
  function goToCheckout(trigger) {
    if (typeof window.yampiClick === 'function') { window.yampiClick(trigger); return; }
    toast('O checkout seguro não carregou. Abra a sacola e tente novamente.');
    api.checkout();
  }

  /* ---------------------------------------------------------- menu e sacola */

  var overlayTrigger = null;

  function setPageInert(state) {
    ['.zs', '.zs-bar', '.zs-wa'].forEach(function (selector) {
      var node = $(selector);
      if (!node) return;
      if (state) node.setAttribute('inert', '');
      else node.removeAttribute('inert');
    });
  }

  function focusDialog(el) {
    window.requestAnimationFrame(function () {
      var target = $('.zs-menu__close, .zs-cart__close', el) || $('button, a, input, select, textarea', el);
      if (target) target.focus();
    });
  }

  function openCart(event) {
    var el = $('[data-zs-cart]');
    if (!el) return;
    var busca = $('[data-zs-search]');
    if (busca) busca.hidden = true;
    el.classList.remove('zs-fechando');
    overlayTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    el.hidden = false;
    var menu = $('[data-zs-menu]');
    if (menu) menu.hidden = true;
    document.body.classList.add('zs-locked');
    setPageInert(true);
    focusDialog(el);
    track('view_cart', { value: (CART.total_price || 0) / 100, items: lineItems(CART) });
  }
  function openMenu(event) {
    var el = $('[data-zs-menu]');
    if (!el) return;
    var buscaEl = $('[data-zs-search]');
    if (buscaEl) buscaEl.hidden = true;
    el.classList.remove('zs-fechando');
    overlayTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    el.hidden = false;
    var c = $('[data-zs-cart]');
    if (c) c.hidden = true;
    document.body.classList.add('zs-locked');
    setPageInert(true);
    focusDialog(el);
    contaAbertura(el);
  }
  // ---- Busca em gaveta -----------------------------------------------
  // O clique no "Buscar" nao navega mais: abre aqui e mostra o resultado
  // sem sair da pagina. O href do link continua valendo sem JS.
  var buscaTimer = null;
  var buscaTermo = '';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function pintaBusca(html) {
    var box = $('[data-zs-search-results]');
    if (box) box.innerHTML = html;
  }

  function buscaSugestoes(termo) {
    var t = (termo || '').trim();
    if (t.length < 2) { pintaBusca(''); return; }
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = raiz + 'search/suggest.json?q=' + encodeURIComponent(t) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (t !== buscaTermo) return;                    // resposta velha: descarta
        var itens = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!itens.length) {
          pintaBusca('<p class="zs-search__vazio">Nada encontrado para &ldquo;' + esc(t) + '&rdquo;.</p>');
          return;
        }
        var html = itens.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var preco = '';
          if (p.price != null) {
            var cents = Math.round(parseFloat(String(p.price).replace(',', '.')) * 100);
            if (!isNaN(cents)) preco = money(cents);
          }
          return '<a class="zs-search__hit" href="' + esc(p.url) + '">' +
                 (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="zs-search__hit-sem"></span>') +
                 '<span class="zs-search__hit-nome">' + esc(p.title) + '</span>' +
                 '<span class="zs-search__hit-preco">' + preco + '</span></a>';
        }).join('');
        var raizBusca = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search?q=';
        html += '<a class="zs-search__todos" href="' + raizBusca + encodeURIComponent(t) + '">Ver todos os resultados</a>';
        pintaBusca(html);
      })
      .catch(function () { pintaBusca(''); });
  }

  function openSearch(event) {
    var el = $('[data-zs-search]');
    if (!el) return;
    if (event && event.preventDefault) event.preventDefault();
    el.classList.remove('zs-fechando');
    overlayTrigger = event && event.currentTarget ? event.currentTarget : document.activeElement;
    el.hidden = false;
    ['[data-zs-menu]', '[data-zs-cart]'].forEach(function (sel) {
      var o = $(sel); if (o) o.hidden = true;
    });
    document.body.classList.add('zs-locked');
    setPageInert(true);
    window.requestAnimationFrame(function () {
      var campo = $('[data-zs-search-input]', el);
      if (campo) { campo.focus(); campo.select(); }
    });
  }

  // Ovo de pascoa: na 31a abertura do menu na mesma sessao, o boneco aparece,
  // aponta pro Fechar e balanca o dedo. sessionStorage para valer por visita;
  // em aba anonima o acesso pode falhar, entao tudo dentro de try.
  var EGG_CHAVE = 'zs-menu-aberturas';
  var EGG_ALVO = 31;

  function contaAbertura(painel) {
    var n;
    try {
      n = (parseInt(window.sessionStorage.getItem(EGG_CHAVE), 10) || 0) + 1;
      window.sessionStorage.setItem(EGG_CHAVE, String(n));
    } catch (e) { return; }
    if (n !== EGG_ALVO) return;
    var egg = $('[data-zs-egg]', painel);
    if (!egg) return;
    egg.hidden = false;
    egg.classList.remove('zs-egg--roda');
    void egg.offsetWidth;                       // forca reflow: reinicia a animacao
    egg.classList.add('zs-egg--roda');
    window.setTimeout(function () {
      egg.classList.remove('zs-egg--roda');
      egg.hidden = true;
    }, 4500);
  }

  function closeAll() {
    var abertas = $$('[data-zs-menu]:not([hidden]), [data-zs-cart]:not([hidden]), [data-zs-search]:not([hidden])');
    var semMovimento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Só devolve scroll, inert e foco DEPOIS que a gaveta saiu da tela. Fazer
    // isso durante a animação faz a página pular, que era o que parecia corte.
    function liberar() {
      if ($('[data-zs-menu]:not([hidden])') || $('[data-zs-cart]:not([hidden])') || $('[data-zs-search]:not([hidden])')) return;
      document.body.classList.remove('zs-locked');
      setPageInert(false);
      if (overlayTrigger && typeof overlayTrigger.focus === 'function') overlayTrigger.focus();
      overlayTrigger = null;
    }

    if (!abertas.length || semMovimento) {
      abertas.forEach(function (el) { el.hidden = true; });
      liberar();
      return;
    }

    abertas.forEach(function (el) { el.classList.add('zs-fechando'); });
    window.setTimeout(function () {
      abertas.forEach(function (el) {
        if (!el.classList.contains('zs-fechando')) return;   // reaberta nesse meio tempo
        el.classList.remove('zs-fechando');
        el.hidden = true;
      });
      liberar();
    }, 310);                                                  // um pouco alem dos 300ms da animacao
  }

  function trapFocus(event) {
    if (event.key !== 'Tab') return;
    var dialog = $('[data-zs-menu]:not([hidden])') || $('[data-zs-cart]:not([hidden])') || $('[data-zs-search]:not([hidden])');
    if (!dialog) return;
    var nodes = $$('a[href], button:not([disabled]):not([hidden]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', dialog)
      .filter(function (node) { return node.offsetParent !== null; });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function bind() {
    $$('[data-zs-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });
    $$('[data-zs-open-menu]').forEach(function (b) { b.addEventListener('click', openMenu); });
    $$('[data-zs-close]').forEach(function (b) { b.addEventListener('click', closeAll); });
    $$('[data-zs-open-search]').forEach(function (b) { b.addEventListener('click', openSearch); });
    var campoBusca = $('[data-zs-search-input]');
    if (campoBusca) {
      campoBusca.addEventListener('input', function () {
        buscaTermo = this.value;
        window.clearTimeout(buscaTimer);
        buscaTimer = window.setTimeout(function () { buscaSugestoes(buscaTermo); }, 220);
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
      trapFocus(e);
    });

    // "Comprar" direto no card e "Adicionar" do upsell da sacola.
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-zs-card-add]') : null;
      if (!b || b.disabled) return;
      b.disabled = true;
      add(b.dataset.variantId, 1, {
        title: b.dataset.productTitle || '',
        variant: b.dataset.variantTitle || '',
        price: parseInt(b.dataset.price, 10) || 0
      }).catch(function (err) { toast(err.message || 'Não deu para adicionar'); })
        .then(function () { b.disabled = false; });
    });

    var bar = $('[data-zs-bar-cta]');
    if (bar) {
      bar.addEventListener('click', function () {
        if (this.dataset.mode === 'cart') { openCart(); return; }
        var rail = $('[data-zs-rail]') || $('[data-zs-buy]');
        if (rail) {
          var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          window.scrollTo({ top: rail.getBoundingClientRect().top + window.scrollY - 80, behavior: reducedMotion ? 'auto' : 'smooth' });
        } else if (DATA.bar_link) {
          window.location.href = DATA.bar_link;
        }
      });
    }

    var checkout = $('[data-zs-checkout]');
    if (checkout) {
      checkout.addEventListener('click', function () {
        if (!(CART.item_count > 0)) return;
        track('begin_checkout', { value: (CART.total_price || 0) / 100, items: lineItems(CART) });
        goToCheckout(checkout);
      });
    }

    var news = $('[data-zs-news]');
    if (news) {
      news.addEventListener('submit', function (e) {
        var email = $('input[type="email"]', news);
        if (!email || !email.value) return;
        track('sign_up', { method: 'newsletter' });
        if (PREVIEW) {
          e.preventDefault();
          var done = $('[data-zs-news-done]', news);
          if (done) done.hidden = false;
          if (e.target.reset) e.target.reset();
        }
      });
    }

    var search = $('[data-zs-search]');
    if (search) {
      search.addEventListener('submit', function () {
        var q = $('input[name="q"]', search);
        if (q && q.value) track('search', { search_term: q.value });
      });
    }

    document.addEventListener('zoss:checkout_error', function (event) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'checkout_error',
          checkout_provider: 'yampi',
          error_message: event.detail && event.detail.message ? event.detail.message : 'unknown'
        });
      } catch (ignore) {}
    });
  }

  /* -------------------------------------------------------- contagem regressiva */

  function countdown() {
    var clocks = $$('[data-zs-clock]');
    if (!clocks.length || !DATA.countdown_end) return;
    var end = new Date(DATA.countdown_end).getTime();
    if (isNaN(end)) return;
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var timer = setInterval(function () {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      var d = Math.floor(left / 86400);
      var text = (d > 0 ? d + 'd ' : '') + pad(Math.floor((left % 86400) / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
      clocks.forEach(function (c) { c.textContent = text; });
      if (left === 0) {
        clearInterval(timer);
        $$('.zs-countdown').forEach(function (s) { s.hidden = true; });
      }
    }, 1000);
  }

  /* ------------------------------------------------------------------- init */

  function init() {
    bind();
    countdown();
    refresh().catch(function () {});
    document.addEventListener('zoss:refresh_cart', function () { refresh().catch(function () {}); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  return {
    add: add,
    refresh: refresh,
    open: openCart,
    close: closeAll,
    track: track,
    toast: toast,
    money: money,
    installments: INSTALLMENTS,
    promoQty: function () { return promotionQuantity(CART); },
    get cart() { return CART; }
  };
})();
